import logEvent from "@/apps/merchant3/services/event-logs.service";
import EventLogs from "@/apps/merchant3/types/EventLogs";
import logAction from "@/apps/merchant3/services/action-logs.service";
import ActionLogs from "@/apps/merchant3/types/ActionLogEvents";
import { IStateCart } from "@/apps/merchant3/models/IStateCart";
import { Store } from "vuex";

export const logSendLatestCart = (cart: IStateCart): void => {
  const data: { cart: IStateCart } = { cart: cart };
  logEvent(EventLogs.Events.OFFER_CART_DATA_RECORDED, data);
  logAction(ActionLogs.Events.SEND_LATEST_CART, data);
};

export const logPostSelectOffers = (
  selectedOffer: string | number,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  store: Store<any>
): void => {
  logEvent(EventLogs.Events.OFFER_SELECTED, {
    Months: selectedOffer,
  });

  const data = {
    months: store.state.carts.months,
    downPayment: store.state.carts.downPayment,
    retailPrice: store.state.carts.retailPrice,
  };

  logEvent(EventLogs.Events.OFFER_CONTINUE_BUTTON_CLICKED, data);
  logAction(ActionLogs.Events.PRICING_VALID_DOWNPAYMENT_AND_TERM, data);
  logAction(ActionLogs.Events.PRICING_CAN_CONTINUE_NEXT_STEP);
};

export const logPricingSetRetailPrice = (retailPrice: number): void => {
  const data = { retailPrice: retailPrice };

  logEvent(EventLogs.Events.PRICE_ENTERED, data);
  logAction(ActionLogs.Events.PRICING_SET_RETAIL_PRICE, data);
};

export const logPricingSetDownPayment = (downPayment: number): void => {
  const data = { downPayment: downPayment };
  logEvent(EventLogs.Events.DOWN_PAYMENT_ENTERED, data);
  logAction(ActionLogs.Events.PRICING_SET_DOWNPAYMENT, data);
};

export const logPricingValidPayment = (): void => {
  logEvent(EventLogs.Events.DOWN_PAYMENT_VALIDATED);
  logAction(ActionLogs.Events.PRICING_VALID_DOWNPAYMENT);
};

export const logDownpaymentReductionMessage = (
  minDownPayment: number | string | undefined | null,
  minDownPaymentUndiscounted: number | string | undefined | null,
  isPromotionalDiscountApplied: boolean | null | undefined,
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  store: Store<any>
): void => {
  const data = {
    country: store.state.merchant?.merchant?.country,
    modelId: store.state.carts?.deviceModelId,
    devicePrice: store.state.carts?.priceWithSalesTax,
    downpayment: store.state.carts?.downPayment,
    minDownpaymentAutofilled: minDownPayment,
    minDownpaymentUndiscounted: minDownPaymentUndiscounted || 0,
    downpaymentReductionMessageDisplayed:
      (isPromotionalDiscountApplied &&
        store.state?.carts?.experiments?.promoDPExperiment) ||
      false,
  };
  logEvent(EventLogs.Events.DOWN_PAYMENT_REDUCTION_DATA_RECORDED, data);
  logAction(ActionLogs.Events.DOWNPAYMENT_REDUCTION_MESSAGE, data);
};

export const logPricingSetManufacturer = (manufacturer: string): void => {
  const data = { manufacturer: manufacturer };
  logEvent(EventLogs.Events.MANUFACTURER_SELECTED, data);
  logAction(ActionLogs.Events.PRICING_SET_MANUFACTURER, data);
};

export const logPricingSetFamily = (
  deviceFamily: string,
  deviceFamilyId: string
): void => {
  const data = {
    deviceFamily: deviceFamily,
    deviceFamilyId: deviceFamilyId,
  };
  logEvent(EventLogs.Events.DEVICE_FAMILY_SELECTED, data);
  logAction(ActionLogs.Events.PRICING_SET_FAMILY, data);
};

export const logPricingSetDevice = (
  deviceModel: string | null,
  deviceId: string | number | null
): void => {
  const data = { deviceModel: deviceModel, deviceId: deviceId };

  logEvent(EventLogs.Events.DEVICE_MODEL_SELECTED, data);
  logAction(ActionLogs.Events.PRICING_SET_DEVICE, data);
};
